import { render, staticRenderFns } from "./AddNewReceipt.vue?vue&type=template&id=75584c51&scoped=true&"
import script from "./AddNewReceipt.vue?vue&type=script&lang=js&"
export * from "./AddNewReceipt.vue?vue&type=script&lang=js&"
import style0 from "./AddNewReceipt.vue?vue&type=style&index=0&id=75584c51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75584c51",
  null
  
)

export default component.exports